<template lang="html">
  <div class="page">
    <header class="hero">
      <nav class="nav nav--desktop">
        <div class="nav__top">
          <img src="./assets/logoOrmet.svg" alt="Logo" class="nav__logo">
          <a href="#6" class="nav__contact">
            <p class="nav__contact-phone">+48 518 202 433</p>
            <div class="nav__contact-btn">{{ $t("nav.contact") }}</div>
          </a>
        </div>
        <div class="nav__bottom">
          <a href="#5" class="nav__link">{{ $t("nav.products") }}</a>
          <a href="#3" class="nav__link">{{ $t("nav.latches") }}</a>
          <a href="#4" class="nav__link">{{ $t("nav.centers") }}</a>
          <LangTranslate class="nav__lang" />
        </div>
      </nav>

      <nav class="nav nav--mobile">
        <LangTranslate class="nav__lang" />
        <img src="./assets/logoOrmet.svg" alt="Logo" class="nav__logo">
        <button 
          class="nav__toggle" 
          :class="{ 'nav__toggle--active': mobileNav }" 
          @click="turnMenu()" 
          aria-controls="primary-navigation"
        >
          <svg class="nav__icon" viewBox="0 0 100 100" width="80">
            <rect class="nav__line nav__line--top" width="80" height="10" x="10" y="25" rx="5"></rect>
            <rect class="nav__line nav__line--middle" width="80" height="10" x="10" y="45" rx="5"></rect>
            <rect class="nav__line nav__line--bottom" width="80" height="10" x="10" y="65" rx="5"></rect>
          </svg>
        </button>
        <div class="nav__menu" v-if="mobileNav">
          <a href="#2" class="nav__link" @click="turnMenu()">{{ $t("history.header") }}</a>
          <a href="#3" class="nav__link" @click="turnMenu()">{{ $t("nav.latches") }}</a>
          <a href="#4" class="nav__link" @click="turnMenu()">{{ $t("nav.centers") }}</a>
          <a href="#5" class="nav__link" @click="turnMenu()">{{ $t("nav.products") }}</a>
          <a href="#6" class="nav__link" @click="turnMenu()">{{ $t("nav.contact") }}</a>
        </div>
      </nav>

      <article class="hero__content">
        <h2 class="hero__title">{{ $t("about.header") }}</h2>
        <p class="hero__text">{{ $t("about.content") }}</p>
        <a href="#5" class="hero__btn">{{ $t("about.button") }}</a>
      </article>
    </header>

    <section id="2" class="section story">
      <article class="story__content">
        <h2 class="section__title">{{ $t("history.header") }}</h2>
        <p class="story__text">{{ $t("history.content") }}</p>
        <a href="#6" class="story__btn">{{ $t("nav.contact") }}</a>
      </article>
      <img src="./assets/pexels-cottonbro-studio-7479027.jpg" alt="Machine" class="story__img">
    </section>

    <section id="3" class="section machines" @wheel="handleScroll">
      <h2 class="section__title">{{ $t("nav.latches") }}</h2>
      <div class="machines__slider" ref="container">
        <CncMachines 
          v-for="machine in machines" :key="machine.name" 
          :name="machine.name" :img="machine.img" :advantages="machine.advantages" 
        />
      </div>
    </section>

    <section id="4" class="section machines" @wheel="reverseScroll">
      <h2 class="section__title">{{ $t("nav.centers") }}</h2>
      <div class="machines__slider" ref="container2">
        <CncMachines 
          v-for="center in centers" :key="center.name" 
          :name="center.name" :img="center.img" :advantages="center.advantages" 
        />
      </div>
    </section>

    <section id="5" class="section products">
      <h2 class="section__title products__title">{{ $t("nav.products") }}</h2>
      <img src="./assets/product1.jpg" alt="Image of products" class="products__img products__img--1">
      <img src="./assets/product2.jpg" alt="Image of products" class="products__img products__img--2">
      <img src="./assets/product3.jpg" alt="Image of products" class="products__img products__img--3">
      <img src="./assets/product4.jpg" alt="Image of products" class="products__img products__img--4">
      <img src="./assets/product5.jpg" alt="Image of products" class="products__img products__img--5">
    </section>

    <section id="6" class="section contact">
      <article class="contact__content">
        <h2 class="section__title">{{ $t("contactUs.header") }}</h2>
        <h3 class="contact__subtitle">"ORMET" Filip Orłowski</h3>
        
        <p class="contact__info"><span class="material-symbols-outlined contact__icon">location_on</span>{{ $t("contactUs.localization") }}</p>
        <ul class="contact__list">
          <li class="contact__list-item">ul. Przemysłowa 5, 86-061 Brzoza</li>
        </ul>
        
        <p class="contact__info"><span class="material-symbols-outlined contact__icon">mail</span>Mail</p>
        <ul class="contact__list">
          <li class="contact__list-item">info@ormet.eu</li>
        </ul>
        
        <p class="contact__info"><span class="material-symbols-outlined contact__icon">call</span>{{ $t("contactUs.phone") }}</p>
        <ul class="contact__list">
          <li class="contact__list-item">Filip Orłowski +48 518 202 433</li>
          <li class="contact__list-item">Janusz Orłowski +48 517 068 244</li>
        </ul>
        
        <p class="contact__info"><span class="material-symbols-outlined contact__icon">text_snippet</span>NIP: 9671443479 REGON: 388260890</p>
      </article>
      
      <iframe 
        class="contact__map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2395.51717981179!2d18.013582177083883!3d53.10090569305925!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47030dad8cc9a103%3A0x4938733a67fd5afb!2sOrmet!5e0!3m2!1spl!2spl!4v1688724296477!5m2!1spl!2spl"
        width="800" height="600" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade" title="Google map">
      </iframe>
    </section>

    <footer class="footer">
      <p class="footer__text">{{ $t("nav.footer") }}</p>
    </footer>

  </div>
</template>

<script>
import LangTranslate from './components/langTranslate.vue';
import CncMachines from './components/CncMachines.vue';

export default {
  components: { CncMachines, LangTranslate },
  data() {
    return {
      initialScrollLeft: 0,
      initialScrollLeft2: 0,
      mobileNav: false,
    }
  },
  computed: {
    machines() {
      return [
        {
          name: "AVIA Turn 30M",
          img: require("@/assets/avia.jpg"),
          advantages: [
            "15 kW",
            this.$t("latches.avia30.one"),
            this.$t("latches.avia30.two"),
            this.$t("latches.avia30.three"),
          ]
        },
        {
          name: "Nakamura TW 20",
          img: require("@/assets/Nakamura20.jpg"),
          advantages: [
            this.$t("latches.nakamura20.one"),
            this.$t("latches.nakamura20.two"),
            this.$t("latches.nakamura20.three"),
            this.$t("latches.nakamura20.four"),
            this.$t("latches.nakamura20.five"),
            this.$t("latches.nakamura20.six"),
            this.$t("latches.nakamura20.seven"),
            this.$t("latches.nakamura20.eight"),
          ]
        },
        {
          name: "Takisawa EX-106",
          img: require("@/assets/Takisawa106.jpg"),
          advantages: [
            this.$t("latches.takisawa106.one"),
            this.$t("latches.takisawa106.two"),
          ]
        },
        {
          name: "Takisawa EX-110",
          img: require("@/assets/Takisawa110.jpg"),
          advantages: [
            this.$t("latches.takisawa110.one"),
            this.$t("latches.takisawa110.two"),
            this.$t("latches.takisawa110.three"),
            this.$t("latches.takisawa110.four"),
          ]
        },
        {
          name: "Mexpol TUB 40",
          img: require("@/assets/TUB40.jpg"),
          advantages: [
            this.$t("latches.mexpol40.one"),
            this.$t("latches.mexpol40.two"),
            this.$t("latches.mexpol40.three"),
            this.$t("latches.mexpol40.four"),
            this.$t("latches.mexpol40.five"),
          ]
        },
        {
          name: "Doosan Puma 2600Y",
          img: require("@/assets/Doosan.jpg"),
          advantages: [
            "22 kW",
            this.$t("latches.doosan.one"),
            this.$t("latches.doosan.two"),
            this.$t("latches.doosan.three"),
          ]
        },
        {
          name: "Pila Everising S-250 HA",
          img: require("@/assets/PilaS250.jpg"),
          advantages: [
            this.$t("latches.pilaS.one"),
            this.$t("latches.pilaS.two"),
          ]
        },
        {
          name: "Pila Berg & Schmid",
          img: require("@/assets/pilaBetg.jpg"),
          advantages: [
            this.$t("latches.pilaB.one"),
            this.$t("latches.pilaB.two"),
          ]
        }
      ]
    },
    centers() {
      return [
        {
          name: "AVIA VMC 1000",
          img: require("@/assets/Avia1000.jpg"),
          advantages: [
            this.$t("center.avia1000.1"),
            this.$t("center.avia1000.2"),
            this.$t("center.avia1000.3"),
            this.$t("center.avia1000.4"),
          ]
        },
        {
          name: "AVIA VMC 650",
          img: require("@/assets/Avia650.jpg"),
          advantages: [
            this.$t("center.avia650.1"),
            this.$t("center.avia650.2"),
            this.$t("center.avia650.3"),
            this.$t("center.avia650.4"),
            this.$t("center.avia650.5"),
          ]
        },
        {
          name: "LERINC V7",
          img: require("./assets/LerincV7.jpg"),
          advantages: [
            this.$t("center.lenric.1"),
            this.$t("center.lenric.2"),
            this.$t("center.lenric.3"),
            this.$t("center.lenric.4"),
          ]
        },
        {
          name: "AVIA VMC 800",
          img: require("@/assets/Avia800.jpg"),
          advantages: [
            this.$t("center.avia800.1"),
            this.$t("center.avia800.2"),
            this.$t("center.avia800.3"),
            this.$t("center.avia800.4"),
            this.$t("center.avia800.5"),
          ]
        }
      ]
    }
  },
  mounted() {
    this.initialScrollLeft = this.$refs.container.scrollLeft;
    this.initialScrollLeft2 = this.$refs.container2.scrollLeft;
  },
  methods: {
    handleScroll(event) {
      const container = this.$refs.container;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;

      if (
        (event.deltaY < 0 && container.scrollLeft > 0) ||
        (event.deltaY > 0 && container.scrollLeft < maxScrollLeft)
      ) {
        event.preventDefault();
        container.scrollLeft += event.deltaY;
      } else if (event.deltaY > 0 && container.scrollLeft === this.initialScrollLeft) {
        event.stopPropagation();
      }
    },
    reverseScroll(event) {
      const container = this.$refs.container2;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;

      if (
        (event.deltaY < 0 && container.scrollLeft > 0) ||
        (event.deltaY > 0 && container.scrollLeft < maxScrollLeft)
      ) {
        event.preventDefault();
        container.scrollLeft += event.deltaY;
      } else if (event.deltaY > 0 && container.scrollLeft === this.initialScrollLeft2) {
        event.stopPropagation();
      }
    },
    turnMenu() {
      this.mobileNav = !this.mobileNav;
    },
  },
}
</script>